module.exports = __webpack_public_path__ + "fc8b7a83b9be2558b4ee2fe36a37e6e6.png";